import cn from 'classnames'
import { memo } from 'react'

import { Translation } from 'cng-common/features/translations'

import { promotionProductTranslationKey } from '../../configs/translation'
import { resolveProductImageKind } from '../../lib/resolveProductImageKind'
import { PromotionSkuView } from '../../models'
import { OfferMarkerList } from '../offerMarker'
import { ProductImage } from '../productImage'

import styles from './SkuCard.module.scss'

interface Props {
  sku: PromotionSkuView
  className?: string
}

export const SkuCard = memo<Props>(({ sku, className }) => {
  return (
    <article className={cn(styles.root, className)}>
      <ProductImage
        className={styles.image}
        src={sku.imageUrl}
        alt={sku.name}
        kind={resolveProductImageKind(sku.name)}
      />

      <div className={styles.info}>
        <h4 className={styles.name} title={sku.name}>
          {sku.name}
        </h4>
        <div className={styles.identity}>
          <span className={styles.productLineCode}>{sku.productLineCode}</span>
          <span className={styles.separator} aria-hidden="true" />
          <span className={styles.badge}>{sku.productId}</span>
        </div>
        {/* Nobody reported: the pair «Stock: —» would read as a number of zero. */}
        {sku.stock !== null && (
          <div className={styles.stock}>
            <Translation text={`${promotionProductTranslationKey}-stock`} span />
            <span>{sku.stock}</span>
          </div>
        )}
      </div>

      <span className={styles.country}>{sku.countryName}</span>

      <OfferMarkerList markers={sku.markers} />

      {sku.productFinderUrl && (
        <a
          className={styles.finderLink}
          href={sku.productFinderUrl}
          target="_blank"
          rel="noreferrer"
        >
          <Translation text={`${promotionProductTranslationKey}-go-to-product-finder`} span />
        </a>
      )}
    </article>
  )
})

SkuCard.displayName = 'SkuCard'
